import { Select, Text } from "@ttc3k/trekker";
import {
  EnumGuestTierType,
  Maybe,
  PriceTier,
  PurchasedProductGuestsPerTier,
} from "gql/generated";
import { useTranslation } from "react-i18next";
import { getMultilingualString } from "shared/utils";
import { Box, Flex } from "styled-system/jsx";
import { useBookerContext } from "widgets/booker/contexts";

type GuestCountsProps = {
  guests: PurchasedProductGuestsPerTier[];
  onUpdateGuests: (g: PurchasedProductGuestsPerTier) => void;
  priceTiers: Maybe<PriceTier>[] | PriceTier[];
  guestMaximum: number | undefined | null;
};

export const GuestCounts = ({
  guests,
  onUpdateGuests,
  priceTiers,
  guestMaximum,
}: GuestCountsProps) => {
  const { language } = useBookerContext();
  const { t } = useTranslation("booker", { keyPrefix: "GUESTS_PAGE" });
  return (
    <Flex flexDir={"column"} gap={"250"}>
      {guests.length > 0 &&
        guests.map(g => {
          const fullTier = priceTiers.find(t => t?._id === g.tierId);
          const isAdultTier = fullTier?.type === EnumGuestTierType.Adult;
          const options = Array.from({
            length: guestMaximum && guestMaximum > 0 ? guestMaximum + 1 : 21,
          }).map((_, i) => ({
            value: i.toString(),
            label: i.toString(),
            disabled: i === 0 && isAdultTier,
          }));

          const collection = Select.createCollection({ items: options });

          const handleUpdateGuestCount = (newCount: string) => {
            onUpdateGuests({ ...g, count: Number(newCount) });
          };
          return (
            <Flex
              key={g.tierId}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Box>
                {fullTier?.type && (
                  <Text
                    visual={"bodyMedium"}
                    color={"black"}
                    textTransform={"capitalize"}
                  >
                    {t(`GUEST_TYPES.${fullTier.type}`)}
                  </Text>
                )}
                {fullTier?.label && (
                  <Text visual={"smallMedium"} color={"text.light"} mt={"50"}>
                    {getMultilingualString(fullTier?.label, language)}
                  </Text>
                )}
              </Box>
              <Select.Root
                collection={collection}
                value={[g.count.toString()]}
                placeholder={"0"}
                maxW={"140px"}
                css={{
                  "& [data-scope='select'][data-part='trigger']": {
                    bg: "white",
                  },
                }}
                onValueChange={({ value }: { value: string[] }) =>
                  handleUpdateGuestCount(value[0])
                }
              >
                {collection.items.map(v => (
                  <Select.Item key={v.value} item={v} />
                ))}
              </Select.Root>
            </Flex>
          );
        })}
      <div></div>
    </Flex>
  );
};
